"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const nav_frontend_typografi_1 = require("nav-frontend-typografi");
const nav_frontend_lenker_1 = __importDefault(require("nav-frontend-lenker"));
require("nav-frontend-skjema-style");
class Feiloppsummering extends React.Component {
    render() {
        const _a = this.props, { children, className, innerRef, tittel, feil, customFeilRender } = _a, rest = __rest(_a, ["children", "className", "innerRef", "tittel", "feil", "customFeilRender"]);
        return (React.createElement("div", Object.assign({ ref: innerRef, tabIndex: 0, role: "region", className: (0, classnames_1.default)("feiloppsummering", className) }, rest),
            typeof tittel === "string" ? (React.createElement(nav_frontend_typografi_1.Undertittel, null, tittel)) : (tittel),
            React.createElement("ul", { className: "feiloppsummering__liste" }, feil.map((item) => (React.createElement("li", { key: item.skjemaelementId }, customFeilRender ? (customFeilRender(item)) : (React.createElement(nav_frontend_lenker_1.default, { href: `#${item.skjemaelementId}` }, item.feilmelding))))))));
    }
}
exports.default = Feiloppsummering;
